import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "chats-search-list" }
const _hoisted_2 = { class: "chats-search-list__dialogs-list" }
const _hoisted_3 = {
  key: 1,
  class: "empty-list"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "chats-search-list__dialogs-list-item-logo" }
const _hoisted_6 = {
  key: 0,
  class: "chats-search-list__dialogs-list-item-logo-img",
  alt: "Avatar"
}
const _hoisted_7 = {
  key: 1,
  class: "chats-search-list__dialogs-list-item-logo-text"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "chats-search-list__messages-list" }
const _hoisted_10 = {
  key: 1,
  class: "empty-list"
}

import {
	computed,
	onMounted,
	ref,
	watch
} from "vue";
import {
	ChatsApi,
	SearchDialog,
	SearchMessage
} from "@/ api/ChatsApi";
import { debounce } from "lodash";
import AppLoader from "@/components/common/AppLoader.vue";
import { highlightSearchText } from "@/utils/textHelpers";
import ChatDialog from "@/components/main/chat-panel/ChatDialog.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatSearchList',
  props: {
    search: {}
  },
  emits: ["on-open-dialog", "on-open-message"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(true);
const dialogs = ref<SearchDialog[] | null>()
const messages = ref<SearchMessage[] | null>(null)

const onFetchDialogsAndMessages = async () => {
	if (!props.search) {
		dialogs.value = null
		messages.value = null
		loading.value = false
		return
	}
	try {
		loading.value = true;
		await Promise.all([
			ChatsApi.searchDialogs(props.search),
			ChatsApi.searchMessages(props.search)
		]).then(results => {
			dialogs.value = results[0].data ?? null;
			messages.value = results[1].data ?? null;
		})
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
}

const openDialog = (dialog: SearchDialog) => {
	emit('on-open-dialog', dialog)
}

const openMessage = (message: SearchMessage) => {
	emit('on-open-message', message)
}

const debouncedSearch = debounce(onFetchDialogsAndMessages, 500)

watch(() => props.search, () => {
	debouncedSearch()
})

const dialogsStyle = computed(() => {
	if (!dialogs.value || loading.value) {
		return {
			flex: 1
		}
	}

	return {
		height: 'fit-content',
	}
})

const messagesStyle = computed(() => {
	if (!messages.value || loading.value) {
		return {
			flex: 1
		}
	}

	return {
		height: 'fit-content',
	}
})

onMounted(async () => {
	await onFetchDialogsAndMessages()
})

return (_ctx: any,_cache: any) => {
  const _directive_img_fade = _resolveDirective("img-fade")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "chats-search-list__dialogs",
      style: _normalizeStyle(dialogsStyle.value)
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "chats-search-list__dialogs-title" }, "Чаты", -1)),
      _createElementVNode("div", _hoisted_2, [
        (loading.value)
          ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
          : (!dialogs.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " По запросу ничего не найдено "))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(dialogs.value, (dialog) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chats-search-list__dialogs-list-item",
                  key: dialog.Id,
                  onClick: ($event: any) => (openDialog(dialog))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (dialog.PhotoLink)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_6, null, 512)), [
                          [_directive_img_fade, dialog.PhotoLink]
                        ])
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(dialog.PhotoLiter), 1))
                  ]),
                  _createElementVNode("div", {
                    class: "chats-search-list__dialogs-list-item-name",
                    innerHTML: _unref(highlightSearchText)(props.search, dialog.Name)
                  }, null, 8, _hoisted_8)
                ], 8, _hoisted_4))
              }), 128))
      ])
    ], 4),
    _createElementVNode("div", {
      class: "chats-search-list__messages",
      style: _normalizeStyle(messagesStyle.value)
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "chats-search-list__messages-title" }, "Сообщения", -1)),
      _createElementVNode("div", _hoisted_9, [
        (loading.value)
          ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
          : (!messages.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " По запросу ничего не найдено "))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(messages.value, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chats-search-list__messages-list",
                  key: message.Id
                }, [
                  _createVNode(ChatDialog, {
                    dialog: message,
                    "from-search": props.search,
                    onOnOpen: ($event: any) => (openMessage(message))
                  }, null, 8, ["dialog", "from-search", "onOnOpen"])
                ]))
              }), 128))
      ])
    ], 4)
  ]))
}
}

})